import { computed } from "vue";
import { useUsersStore } from "@/stores";
import { storeToRefs } from "pinia";

const COLOR_PALETTE = [
  "#4f46e5", // Indigo
  "#059669", // Emerald
  "#dc2626", // Red
  "#7c3aed", // Violet
  "#ea580c", // Orange
  "#0891b2", // Cyan
];

const GRADIENT_PAIRS = [
  "from-blue-500 to-purple-600", // Blue to Purple - vibrant contrast
  "from-emerald-400 to-cyan-500", // Emerald to Cyan - fresh and bright
  "from-rose-500 to-orange-500", // Rose to Orange - warm sunset
  "from-purple-500 to-pink-500", // Purple to Pink - vibrant magenta range
  "from-amber-400 to-red-500", // Amber to Red - fire gradient
  "from-teal-400 to-blue-600", // Teal to Blue - ocean gradient
];

export function useUserColors() {
  const { users } = storeToRefs(useUsersStore());

  const getUserColorByUsername = (username: string) => {
    const userIndex = users.value.findIndex((u) => u.username === username);
    return userIndex >= 0
      ? COLOR_PALETTE[userIndex % COLOR_PALETTE.length]
      : COLOR_PALETTE[0];
  };

  const getUserColorById = (userId: string) => {
    const userIndex = users.value.findIndex((u) => u.id === userId);
    return userIndex >= 0
      ? COLOR_PALETTE[userIndex % COLOR_PALETTE.length]
      : COLOR_PALETTE[0];
  };

  const getUserGradientByUsername = (username: string) => {
    const userIndex = users.value.findIndex((u) => u.username === username);
    const gradientIndex =
      userIndex >= 0 ? userIndex % GRADIENT_PAIRS.length : 0;
    return `bg-gradient-to-br ${GRADIENT_PAIRS[gradientIndex]}`;
  };

  const getUserGradientById = (userId: string) => {
    const userIndex = users.value.findIndex((u) => u.id === userId);
    const gradientIndex =
      userIndex >= 0 ? userIndex % GRADIENT_PAIRS.length : 0;
    return `bg-gradient-to-br ${GRADIENT_PAIRS[gradientIndex]}`;
  };

  // For charts - get colors for multiple users
  const getChartColors = (usernames: string[]) => {
    return usernames.map((username) => getUserColorByUsername(username));
  };

  // Get all colors from the palette
  const colorPalette = computed(() => COLOR_PALETTE);

  return {
    getUserColorByUsername,
    getUserColorById,
    getUserGradientByUsername,
    getUserGradientById,
    getChartColors,
    colorPalette,
  };
}
